import { render, staticRenderFns } from "./CrearEvento.vue?vue&type=template&id=33cbfdfc&scoped=true"
import script from "./CrearEvento.vue?vue&type=script&lang=js"
export * from "./CrearEvento.vue?vue&type=script&lang=js"
import style0 from "./CrearEvento.vue?vue&type=style&index=0&id=33cbfdfc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbfdfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33cbfdfc')) {
      api.createRecord('33cbfdfc', component.options)
    } else {
      api.reload('33cbfdfc', component.options)
    }
    module.hot.accept("./CrearEvento.vue?vue&type=template&id=33cbfdfc&scoped=true", function () {
      api.rerender('33cbfdfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/CrearEvento.vue"
export default component.exports